import React from 'react'
import clsx from 'clsx'

// The facts line: caption-sized grey text, middle dots between items with
// 12px either side. Pass the items as an array so the separators are drawn
// by CSS - a dot never leads a wrapped line, and dropping an item (the live
// wash count before config has loaded) does not leave a stray dot behind.
//
//   <TrustLine centred items={['26,081 cars washed since 2016', 'Fully insured']} />
export const TrustLine = ({ items = [], centred = false, className }) => {
  const visible = items.filter(Boolean)
  if (visible.length === 0) return null

  return (
    <ul className={clsx('gwmc-trustline', centred && 'gwmc-trustline--centred', className)}>
      {visible.map((item, i) => (
        <li key={i} className="gwmc-trustline-item">
          {item}
        </li>
      ))}
    </ul>
  )
}
